module.exports = __webpack_public_path__ + "static/Calibre-LightItalic-3ede1be73648125ed40cfd07e1292bf1.ttf";